export default __webpack_public_path__ + "static/anatomy-4fd3190324feaacd127d34db66c2c9d8.png";